import axios from "../../../utils/axios";

/**
 * Повертає масив всіх категорій
 * @param {string} lang {ua,en,ru...}
 * @returns 
 */
export const getCategoryList = async (lang) => {
    try {
        const response = await axios.get(`../plugin/market/category/getlist`, {params:{lang:lang}}); 
        return response?.data?.list||null;
    } catch(e) {
        console.log(e);
        return null;
    }
}

/**
 * Повертає категорію по її ІД
 * @param {int} categoryId 
 * @returns 
 */
export const getcategory = async (categoryId) => {
    try {
        const response = await axios.get(`../plugin/market/category/${categoryId}`);
        return response?.data||null;
    } catch(e){
        console.log(e);
        return null;
    }
}

/** 
 * Повертаэ хлыбны крихти категорії
 * @param {int} categoryId 
 * @param {string} lang 
 * @returns 
 */
export const getBreadcrumbs = async (categoryId, lang) => {
    try {
        const response = await axios.get(`../plugin/market/category/breadcrumbs/${categoryId}`, {params:{lang:lang}}); 
        return response?.data?.list||null;
    } catch(e) {
        console.log(e);
        return null;
    }
}

/**
 * Сотрування категорій
 * @param {Array} categories  - масив ID категорій у відсортованому порядку
 * @returns 
 */
export const setOrder = async (categories) => {
    try {
        const response = await axios.post('../plugin/market/category/order', {categories});
        return response?.data?.stat||false;
    } catch(e){
        console.log(e);
        return false;
    }
}

/**
 * Встановлення батьківсьої категорії 
 * @param {*} categoryId 
 * @param {*} parentId 
 * @returns 
 */
export const setParent = async (categoryId, parentId) => {
    try {
        const response = await axios.post(`../plugin/market/category/parent/${categoryId}`, {parentId});
        return response?.data?.stat||false;
    } catch(e){
        console.log(e);
        return false;
    }
}

/**
 * Збереження категорії
 * @param {int} categoryId 
 * @param {Object} saveData 
 * @returns 
 */
export const saveCategory = async (categoryId, saveData) => {
    try {   
        const response = await axios.post(`../plugin/market/category/${categoryId}`, saveData);
        return response.data.stat||false;
    } catch(e) {
        console.error(e);
        return false;
    }
}

/**
 * Створюємо категорію
 * @param {int} createDate.parentId 
 * @param {string} createDate.categoryTitle 
 * @param {string} createDate.lang 
 * @returns 
 */
export const createCategory = async (createData) =>{ 
    try {
        const response = await axios.post('../plugin/market/category/create', createData);
        return response?.data?.ID||false;
    } catch(e){
        console.error(e);
        return false;
    }
}
 
/**
 * Видалення категорії
 * @param {int} categoryId 
 * @returns 
 */
export const deleteCategory = async(categoryId) =>{ 
    try {
        const response = await axios.post(`../plugin/market/category/delete/${categoryId}`);
        return response?.data?.stat||false;
    } catch(e){
        console.error(e);
        return false;
    }
}


/**
 * Зміна статусу категорії
 * @param {int} categoryId 
 * @param {int} status 
 * @returns 
 */
export const setSatus = async (categoryId, status) => {
    try {
        const response = await axios.post(`../plugin/market/category/status/${categoryId}`, {status});
        return response?.data?.stat||false;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Зміна статусу продуктів у всіх категорії 
 * @param {int} categoryId 
 * @param {int} status 
 * @returns 
 */
export const setStatusAllProducts = async (categoryId, status) => {
    try {
        const response = await axios.post(`../plugin/market/category/status/products/${categoryId}`, {status});
        return response?.data?.stat||false;
    } catch(e){
        console.error(e);
        return false;
    }    
}